export const ACTIVE_INSTANCE_STATUSES = ['running', 'waiting', 'suspended'] as const;
export const HISTORY_INSTANCE_STATUSES = ['completed', 'rejected', 'cancelled', 'withdrawn'] as const;
export const FAILED_INSTANCE_STATUSES = ['failed'] as const;

export const ALL_INSTANCE_STATUSES = [
  ...ACTIVE_INSTANCE_STATUSES,
  ...HISTORY_INSTANCE_STATUSES,
  ...FAILED_INSTANCE_STATUSES,
] as const;

export type ProcessInstanceStatus = typeof ALL_INSTANCE_STATUSES[number];

/**
 * The status filter's options, in the order an operator scans them.
 *
 * One home for the grouping, because it used to live as a `statuses` prop passed
 * by four page wrappers — four call sites deciding one thing (svdy-rules §10.5).
 */
export const STATUS_GROUPS = {
  all: ALL_INSTANCE_STATUSES as readonly string[],
  active: ACTIVE_INSTANCE_STATUSES as readonly string[],
  completed: HISTORY_INSTANCE_STATUSES as readonly string[],
  failed: FAILED_INSTANCE_STATUSES as readonly string[],
} as const;

export type StatusGroup = keyof typeof STATUS_GROUPS;
